export default __webpack_public_path__ + "static/media/hht2_ep16_book_wp_02.d3576600.jpg";